import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Aponta para a base URL do novo controller
const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/comprovanteAverbacaoController`);

export default class ComprovanteAverbacaoService {
  axios: typeof axiosInstance;

  constructor() {
    this.axios = axiosInstance;
  }

  // Corresponde a: GET /{id}
  async buscarPorId(id: number | string): Promise<any> {
    try {
      const response = await this.axios.get(`/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar comprovante por ID:', error);
      throw error;
    }
  }

  // Corresponde a: GET /ade/{numeroAde}
  async buscarPorAde(numeroAde: string): Promise<any> {
    try {
      const response = await this.axios.get(`/ade/${numeroAde}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar comprovante por número ADE:', error);
      throw error;
    }
  }

  // Corresponde a: GET /pdf/ade/{numeroAde}
  async baixarComprovantePdf(numeroAde: string): Promise<Blob> {
    try {
      const response = await this.axios.get(`/pdf/ade/${numeroAde}`, {
        responseType: 'blob', // Essencial para o recebimento do arquivo
        headers: {
          'Accept': 'application/pdf'
        }
      });
      return new Blob([response.data], { type: 'application/pdf' });
    } catch (error) {
      console.error('Erro ao gerar/baixar PDF do comprovante:', error);
      throw error;
    }
  }
}